import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { NotificationWarning } from '@dbk/ui-icons';
import { H2 } from '@dbk/ui-text';
import SummaryView from './summary-grid';
import TotalMarketValueView from './market-value-total';
import BlurModal from '../../components/common/blur-modal';
import Modal from '@dbk/ui-modal';
import Error from '../../components/common/error';
import { LoadingCircle } from '../../components/common/loading';
import IsNonActivePortfolio from '../portfolio/dashboard/inacitve-portfolio';
import 'moment/min/locales';
import moment from 'moment';
import SummaryHeader from '../../components/dashboard/market-summary-header';
import PaymentBanner from '../payments/payment-psd2-banner';
import { envConfig } from '../../../db-env-build';
import { EBANKINGWEBUK } from '../../../@extension/CH/src/constants';
import Button from '@dbk/ui-buttons/src/button/button';


/* Landing page for dashboard summary */
class DashboardContainer extends PureComponent {
    constructor(props){
        super(props);
        this.state = {
            noData : false
        }

    }
   async componentWillMount(){
        const { app: { user: { portfolios, portfolioSelection } } } = this.props;
            this.props.payments.setDisableTabs(false);
        if (portfolios && portfolios.length > 0) {
            const id = portfolios[0].id !== null ? portfolios[0].id : portfolios[0].relId;
            portfolioSelection(id, portfolios[0]);
        }
        await this.props.setSpinner(true);
   }

    async componentDidMount(){
        const {
            app: {user: {selectedPortfolioData}},
            userprofile: {prevPrefCurrency ,prefCurrency, setPrefCurrency },
            auth: {destinationCurrency},
            getUserAlerts
        } = this.props;
        if(prefCurrency === undefined) {
            if(destinationCurrency)
                await setPrefCurrency(destinationCurrency)
            else 
                await setPrefCurrency(selectedPortfolioData.referenceCurrency)
        }
         this.props.getDashboardData();
         getUserAlerts();
         if(document.querySelector('.logo-web')){
            document.querySelector('.logo-web').focus();
          }      
    }

    componentDidUpdate(){
        if(document.querySelector('.btnView button')){
            document.querySelector('.btnView button').focus();
        }
    }

    async componentWillUnmount(){
        await this.props.resetVariables();
    }

    /* Will listen when selection changed in widget */
    async componentWillReceiveProps(nextProps){
        const {
            app: {user: {selectedPortfolioData}},
            userprofile: {setPrefCurrency},
            auth: {destinationCurrency}
        } = this.props;
        if(selectedPortfolioData.id !== nextProps.app.user.selectedPortfolioData.id 
            || selectedPortfolioData.relId !== nextProps.app.user.selectedPortfolioData.relId ){
                if(destinationCurrency)
                    await setPrefCurrency(destinationCurrency)
                else 
                    await setPrefCurrency(nextProps.app.user.selectedPortfolioData.referenceCurrency)
                await this.props.setSpinner(true);
                await this.props.getDashboardData(); 
            }

    }
    
    closeBlurModel = async () => {
        await this.props.dashboard.setShowErrorModal(false);
        this.setState({
            noData: true
        });
    };

    renderErrorModal = () => {
        const {  
        dashboard: { showErrorModal, errorTitle, errorMsg } } = this.props;

        return (
            <BlurModal
                visible={showErrorModal}
                doneVisible={false}
                title={<h4>{errorTitle}</h4>}
                onDone={() => this.closeBlurModel()}
            >
                <div className="error-message-container">
                    <NotificationWarning color='#b92635' className="error-icon" width={25} height={25} />
                    <span className="error-message-content">{errorMsg}</span>
                </div>
            </BlurModal>
        )
    }
    renderNotificationModalForMultisign = () => {
        const {  
            i18n : {messages}} = this.props;
    
        return (

            <Modal
                isActive
                disableOutsideClick
                className="multisign-notification-modal"
                onClose={()=>onCancel()}
                header={"Multi-signature payment approval"}
                // header={messages['app.payments.summary.cancelPayment']}
                content={
                <div className="multisign-notification-modal__content">
                   <div>
                        <p>Multi-signatory payments.</p>
                        <p> There are 3 payments pending your approval.</p>
                   </div>
                   <div className='button-container' style={{display:'flex', alignItems: 'center', justifyContent:'flex-end'}}>
                        <Button tertiary className="mr-"  >{messages['app.manageContactDetails.btn.cancel']}</Button>
                        <Button   >{'View'}</Button>
                   </div>
                </div>
                }
            />
        )
    }

  render() {
      const {
          i18n : {messages},
          userprofile: { prefCurrency },
          dashboard: { showSpinner, showErrorModal },
          portfolio : {summary, overallMarketValue },
          discovery: {visible},
          auth: { isNonActivePortfolio }

      } = this.props;
    if(showSpinner && !visible) {
        return (
            <div className="portfolio-ldng-crcle">
            <LoadingCircle />
            </div>
        )
    }
    else if(summary) {
       
       if( overallMarketValue.asOfDate === 0){
        this.props.setPortfolioAsOfDate(moment(summary.asOfDate, 'DD.MM.YYYY').format('YYYY-MM-DD'));
        this.props.setPortfolioEndDate(moment(summary.asOfDate, 'DD.MM.YYYY').format('YYYY-MM-DD'));

       }
       if(overallMarketValue.portfolioTransStartDate === 0 && overallMarketValue.portfolioTransEndDate === 0){ 
        this.props.setPortfolioStartDate(moment(summary.portfolioTransStartDate,'YYYY-MM-DD' ).format('YYYY-MM-DD'));  //WMCE-51369
       }

      return (
        <div className={`dashboard-container ${this.props.ais.isBannerVisible? 'opacityforDashboard': null}`} >
            {/* { envConfig.envConfig === EBANKINGWEBLUX && <PaymentBanner /> } */}

            {/* commenting for future use */}
            {/* {this.renderNotificationModalForMultisign()} */}
            <SummaryHeader
                messages = {messages}
                mktValueTotal = {summary.mktValueInPrefCCYTotal}
                prefCurrency = {prefCurrency}
                asOfDate ={summary.asOfDate}
            />
            <SummaryView pfDetails = {summary.portfolios}/>
            <TotalMarketValueView
                messages = {messages}
                marketTotal = {summary.mktValueInPrefCCYTotal}
            />
            {isNonActivePortfolio && <IsNonActivePortfolio />}
        </div>
               
      );
    }
    else if(showErrorModal && !visible) {
        return (
            <div>
            {this.renderErrorModal()}
            </div>
        );
        }
    else if(this.state.noData){
        return(
            
        <div className="currencyChartNoData">
        <H2>
           {messages['app.profile.consolidatesetup.dataRes']}
           </H2>
        </div>
        );
    }
    else 
    return <div/>
  }

}
export default createContainer({
    $renderError: () => <Error />,
  $queries: {
    i18n: {
      messages: true,
    },    
    app: {
        user: {
            selectedPortfolioData: true,
            portfolios: true,
            portfolioSelection : { $call: 'portfolioSelection' }
        }
    },
    setPortfolioAsOfDate: { $set: 'portfolio.overallMarketValue.asOfDate' },
    setPortfolioStartDate: { $set : 'portfolio.overallMarketValue.portfolioTransStartDate'},
    setPortfolioEndDate: { $set : 'portfolio.overallMarketValue.portfolioTransEndDate'},
    getDashboardData: { $call: 'dashboard.callSummaryAPI'},
    getUserAlerts: { $call: 'alerts.list' },
    getSummaryPageData: { $call: 'portfolio.getSummaryPageData'},
    setSpinner: {$set: 'dashboard.showSpinner'},
    resetVariables: { $call: 'dashboard.resetVariables'},
    dashboard :  {
        showSpinner : true,
        showErrorModal: true,
        errorMsg: true,
        errorTitle: true,
        setShowErrorModal: { $set: 'showErrorModal' }
    },
    discovery: {
        visible: true
    },
    userprofile: {
        prefCurrency: true,
        setPrefCurrency: { $set: 'prefCurrency'},
        prevPrefCurrency: true
    },
    auth: {
        isNonActivePortfolio: true,
        destinationCurrency: true
    },
    portfolio: {
        summary: true,
        overallMarketValue: { 
            asOfDate: true,
            portfolioTransStartDate: true,
            portfolioTransEndDate: true
        },
    },
    ais:{
        isBannerVisible: true
    },
    payments: {
      setDisableTabs: { $set: 'disableTabs' },
    },
    }
})(DashboardContainer);

